module.exports = __webpack_public_path__ + "img/226-db4bc2.png";